












import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Appointments, Messages, Templates, TemplateModel } from '../models'
import { Header, Waitlist, FlashMessage, Ticker, Slideshow } from '../components'

@Component({
  components: { Header, Waitlist, Ticker, Slideshow, FlashMessage },
})
export default class Home extends Vue {
  Appointments = Appointments
  Messages = Messages
  Templates = Templates

  showSlideshow = false

  mounted() {
    const activeTemplate = Templates.entitiesById[Templates.activeId]
    if (activeTemplate) {
      this.showSlideshow = activeTemplate.layout_type === 'split'
    }
  }
}
